import type { OrganicPaidRow } from '../../revenueintel/framework';

type Props = { rows?: OrganicPaidRow[] };

function barWidth(value: number) {
  return `${Math.min(value * 20, 100)}%`;
}

export function OrganicPaidCorrelationPanel({ rows = [] }: Props) {
  return (
    <div className="space-y-4">
      {rows.map((r) => (
        <div key={r.dimension}>
          <div className="flex items-center justify-between text-xs">
            <span className="font-medium text-slate-700 dark:text-slate-300">{r.dimension}</span>
            <span className="text-slate-500">r = {r.correlation.toFixed(2)}</span>
          </div>
          <div className="mt-1 grid grid-cols-2 gap-2">
            <div>
              <p className="text-xs text-slate-500">Organic</p>
              <div className="mt-0.5 h-2 rounded-full bg-slate-100 dark:bg-slate-800">
                <div className="h-2 rounded-full bg-emerald-500" style={{ width: barWidth(r.organic) }} />
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-500">Paid</p>
              <div className="mt-0.5 h-2 rounded-full bg-slate-100 dark:bg-slate-800">
                <div className="h-2 rounded-full bg-brand-500" style={{ width: barWidth(r.paid) }} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
